import HeaderWebsite from "../../components/HeaderWebsite";
import MainBets from "../../components/MainBets";
import Filter from "../../components/Filter";
import { Context } from "../../App";
import { useState } from "react";

export default function LoggedHomePage(props) {
  const {
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    userData,
    accountFeatures,
    valueMin,
    setValueMin,
    valueMax,
    setValueMax,
    betHome,
    setBetHome,
    sports,
    setSports,
    timeEvent,
    setTimeEvent,
    itemsTrash,
    setItemsTrash,
    controllerLocalStorage,
    quantityBetHomeEnabled,
    setQuantityBetHomeEnabled,
    quantitySportsEnabled,
    setQuantitySportsEnabled,
    setlistBehomeEnableds,
    entradasLigth,
    setentradasLigth,
    entradasPro,
    setentradasPro,
    AparecerProf,
    setAparecerProf,
    AparecerVivo,
    setAparecerVivo,
    AparecerLight,
    setAparecerLight,
    AparecerPro,
    setAparecerPro,
    filterOrder,
    setFilterOrder,
    requiredBetHome,
    setRequiredBetHome,
    marketsUnselected,
    setMarketsUnselected,
    clearOldSurebet,
    blacklistWords,
    setBlacklistWords,
    popupWindow,
    setPopupWindow,
    popuwindowsBet,
    setPopupWindowBet,
    setCanGetOperation,
    entradasGlobal,
    setEntradasGlobal,

  } = props;
  //--------------------------------------------------------------------------------------------

  const [threeHouseEntryisActivated, setThreeHouseEntryisActivated] = useState(
    localStorage.getItem("threeHouseEntryisActivated") === "false"
      ? false
      : true,
  );

  return (
    <>
      <HeaderWebsite
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
        notificationVolume={notificationVolume}
        setNotificationVolume={setNotificationVolume}
        userData={userData}
        user={userData}
      />
      <Context.Provider
        value={{
          marketsUnselected,
          setMarketsUnselected,
          clearOldSurebet,
          blacklistWords,
          setBlacklistWords,
          statusMode,
          accountFeatures,
          threeHouseEntryisActivated,
          setThreeHouseEntryisActivated,
          entradasGlobal,
          setEntradasGlobal,
        }}
      >
        <div className="d-flex">
          <MainBets
            valueMin={valueMin}
            valueMax={valueMax}
            betHome={betHome}
            sports={sports}
            timeEvent={timeEvent}
            itemsTrash={itemsTrash}
            setItemsTrash={setItemsTrash}
            statusMode={statusMode}
            controllerLocalStorage={controllerLocalStorage}
            setValueMin={setValueMin}
            setValueMax={setValueMax}
            setBetHome={setBetHome}
            quantityBetHomeEnabled={quantityBetHomeEnabled}
            setQuantityBetHomeEnabled={setQuantityBetHomeEnabled}
            setSports={setSports}
            quantitySportsEnabled={quantitySportsEnabled}
            setQuantitySportsEnabled={setQuantitySportsEnabled}
            setTimeEvent={setTimeEvent}
            isLoggedIn={isLoggedIn}
            showLogoutButton={showLogoutButton}
            notificationVolume={notificationVolume}
            setPopupWindow={setPopupWindow}
            popupWindow={popupWindow}
            setPopupWindowBet={setPopupWindowBet}
            popuwindowsBet={popuwindowsBet}
            user={userData}
            setlistBehomeEnableds={setlistBehomeEnableds}
            setentradasLigth={setentradasLigth}
            entradasLigth={entradasLigth}
            setentradasPro={setentradasPro}
            entradasPro={entradasPro}
            setAparecerProf={setAparecerProf}
            setAparecerVivo={setAparecerVivo}
            setAparecerLight={setAparecerLight}
            setAparecerPro={setAparecerPro}
            AparecerProf={AparecerProf}
            AparecerVivo={AparecerVivo}
            AparecerLight={AparecerLight}
            AparecerPro={AparecerPro}
            filterOrder={filterOrder}
            setFilterOrder={setFilterOrder}
            requiredBetHome={requiredBetHome}
            setRequiredBetHome={setRequiredBetHome}
            setCanGetOperation={setCanGetOperation}
          />
          <Filter
            statusMode={statusMode}
            controllerLocalStorage={controllerLocalStorage}
            valueMin={valueMin}
            setValueMin={setValueMin}
            valueMax={valueMax}
            setValueMax={setValueMax}
            betHome={betHome}
            setBetHome={setBetHome}
            quantityBetHomeEnabled={quantityBetHomeEnabled}
            setQuantityBetHomeEnabled={setQuantityBetHomeEnabled}
            sports={sports}
            setSports={setSports}
            quantitySportsEnabled={quantitySportsEnabled}
            setQuantitySportsEnabled={setQuantitySportsEnabled}
            timeEvent={timeEvent}
            setTimeEvent={setTimeEvent}
            setlistBehomeEnableds={setlistBehomeEnableds}
            setentradasLigth={setentradasLigth}
            entradasLigth={entradasLigth}
            setentradasPro={setentradasPro}
            entradasPro={entradasPro}
            AparecerProf={AparecerProf}
            AparecerLight={AparecerLight}
            AparecerPro={AparecerPro}
            filterOrder={filterOrder}
            setFilterOrder={setFilterOrder}
            requiredBetHome={requiredBetHome}
            setRequiredBetHome={setRequiredBetHome}
          />
        </div>
      </Context.Provider>
    </>
  );
}
